export const TYPE_OF_FIELD_IN_COLUMN = {
  STRING: 'string',
  NUMBER: 'number',
  ACTIONS: 'actions',
  PERCENTAGE: 'percentage',
  SENTIMENT: 'sentiment',
  MOMENTS: 'moment',
  STATUS: 'status',
  DATE: 'date',
  ARRAY: 'array',
  BOOLEAN: 'boolean',
  TIME: 'time',
  JSON: 'json',
  TEXT: 'text',
  USER: 'user'
};
export function ensureArray(input) {
  if (!input) {
    return null;
  }
  if (Array.isArray(input)) {
    // If it's already an array, return it as is
    return input;
  } else {
    // If it's not an array, wrap it in an array and return
    return [input];
  }
}
